module.exports = __webpack_public_path__ + "static/media/img-drag-drop-preview.01b7f8c4.png";